import moment from 'moment';

export const dateFormatter = (date) => moment(date).format('MMMM D, YYYY');
export const timeFormater = (date) => moment(date).format('HH:mm');

export const secondsToMinutesAndSeconds = (seconds) => {
    const result = {};

    result.m = Math.floor(seconds / 60);
    result.s = seconds % 60;

    return result;
};

export const getDaysHoursMinutesSeconds = (durationInMilliseconds, i18next) => {
    const days = Math.floor(durationInMilliseconds / (86400 * 1000));
    durationInMilliseconds -= days * (86400 * 1000);
    const hours = Math.floor(durationInMilliseconds / (60 * 60 * 1000));
    durationInMilliseconds -= hours * (60 * 60 * 1000);
    const minutes = Math.floor(durationInMilliseconds / (60 * 1000));
    durationInMilliseconds -= minutes * (60 * 1000);
    const seconds = Math.floor((durationInMilliseconds / 1000) % 60);
    durationInMilliseconds -= seconds * (60 * 1000);

    //We hardcode because in many countries it is standard with h for hours and m for minutes
    const hour = 'h';
    const min = 'm';

    if (days > 0) {
        return `${days} ${i18next.t('Time.Day.Short')} ${hours} ${hour}`;
    } else if (hours) {
        return `${hours} ${hour} ${minutes} ${min}`;
    } else {
        return (
            (minutes < 10 ? '0' : '') +
            minutes +
            ':' +
            (seconds < 10 ? '0' : '') +
            seconds
        );
    }
};

export const getHoursMinutesSecondsUiFriendlyFromMilliseconds = (
    durationInMilliseconds,
    i18next,
) => {
    const durationInSeconds = Math.floor(durationInMilliseconds / 1000);

    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = Math.floor((durationInSeconds % 3600) % 60);

    if (hours) {
        return `${hours} ${i18next.t('duration.hours')} ${minutes} ${i18next.t(
            'duration.minutes',
        )} ${seconds} ${i18next.t('duration.seconds')}`;
    } else if (minutes) {
        return `${minutes} ${i18next.t(
            'duration.minutes',
        )} ${seconds} ${i18next.t('duration.seconds')}`;
    } else {
        return `${seconds} ${i18next.t('duration.seconds')}`;
    }
};

export const getCurrentDateMinusOneDayForSimlog = () => {
    //1 day somewhat arbitrarily chosen. Figure it's enough to avoid potential timezone problems.
    return moment().subtract(1, 'days').format('YYYY-MM-DD hh:mm:ss');
};

export const getUiFriendlyDuration = (startTime, endTime, i18next) => {
    const durationInMilliseconds = moment
        .duration(moment(endTime).diff(moment(startTime)))
        .asMilliseconds();
    return getHoursMinutesSecondsUiFriendlyFromMilliseconds(
        durationInMilliseconds,
        i18next,
    );
};
